
import { defineComponent, SetupContext, computed } from "vue";
import NativeClient from "@/client/native-client";

export default defineComponent({
  name: "FridgeDetailsConfirmSettingsDialogItem",
  props: {
    /** 項目名 */
    itemName: {
      type: String,
      required: true
    },
    /** 項目の値 */
    itemValue: {
      type: String,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    return {
 
    };
  }
});
